import axios from 'axios';
import {
	GET_ADMIN_PRODUCT_SUCCESS,
	GET_ADMIN_PRODUCT_FAILURE,
	SET_ALERT,
	ADD_PRODUCT_SUCCESS,
	ADD_PRODUCT_FAIL,
	FETCH_PRODUCT_BY_ID,
	FAIL_FETCH_PRODUCT_BY_ID,
	CLEAR_OLD_FETCH_SUCCESS,
	CLEAR_OLD_FETCH_FAIL,
	IMPORT_PRODUCTS_SUCCESS,
	IMPORT_PRODUCTS_FAIL,
} from './index';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const getProducts =
	(offset: number = 0, name: string = '', status: string = '', fb_number: string = '', category_id: string = '', out_of_stock: string = '', sort: string = 'newest') =>
	async (dispatch: any) => {
		const config = {
			headers: {
				'x-auth-token': localStorage.getItem('x-auth-token'),
			},
		};
		const body = { name, status, fb_number, category_id, out_of_stock, sort };
		try {
			const response = await axios.post(
				`${BASE_URL}/api/get-products?offset=${offset}`,
				body,
				config
			);
			dispatch({ type: GET_ADMIN_PRODUCT_SUCCESS, payload: response.data });
			return Promise.resolve();
		} catch (e) {
			dispatch({
				type: SET_ALERT,
				payload: { message: 'Failed to fetch products', status: 'error' },
			});
			dispatch({ type: GET_ADMIN_PRODUCT_FAILURE });
			return Promise.reject(e);
		}
	};

export const addProduct =
	({
		title,
		photo,
		category,
		subcategory,
		fbnumber,
		price,
		description,
		attributes,
		unit,
		quantityPerUnit,
		facPrices,
		groupPrices,
		variants,
	}) =>
	async (dispatch: any) => {
		const config = {
			headers: {
				'x-auth-token': localStorage.getItem('x-auth-token'),
				'content-type': 'multipart/form-data',
			},
		};
		try {
			const formData = new FormData();
			formData.append('name', title || '');
			formData.append('description', description || '');
			formData.append('fbnumber', fbnumber || '');
			formData.append('price', String(price ?? ''));
			formData.append('unit', unit || 'each');
			formData.append('quantity_per_unit', String(quantityPerUnit || '1'));
			formData.append('category', String(category || ''));
			formData.append('subcategory', String(subcategory || ''));
			if (photo) formData.append('photo', photo);
			formData.append('attributes', JSON.stringify(attributes || []));
			formData.append('fac_prices', JSON.stringify(facPrices || []));
			const hasVariants = Array.isArray(variants) && variants.length > 0;
			formData.append(
				'group_prices',
				JSON.stringify(hasVariants ? [] : groupPrices || [])
			);
			formData.append('variants', JSON.stringify(variants || []));

			const response = await axios.post(
				BASE_URL + `/api/create-product`,
				formData,
				config
			);
			if (response.data != null) {
				dispatch({ type: ADD_PRODUCT_SUCCESS, payload: response.data });
				dispatch({
					type: SET_ALERT,
					payload: { message: 'Added product successfully', status: 'success' },
				});
				return Promise.resolve(response.data);
			} else {
				dispatch({
					type: SET_ALERT,
					payload: { message: 'Fail to add product', status: 'error' },
				});
				return Promise.reject(new Error('Fail to add product'));
			}
		} catch (e) {
			dispatch({
				type: SET_ALERT,
				payload: { message: 'Fail to add product', status: 'error' },
			});
			dispatch({ type: ADD_PRODUCT_FAIL });
			return Promise.reject(e);
		}
	};

export const getProductByID = (product_id) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.get(
			BASE_URL + `/api/get-products-by-id?product_id=` + product_id,
			config
		);
		dispatch({ type: FETCH_PRODUCT_BY_ID, payload: response.data });
	} catch (e) {
		dispatch({ type: FAIL_FETCH_PRODUCT_BY_ID });
	}
};

export const fetchStart = () => (dispatch: any) => {
	try {
		dispatch({ type: CLEAR_OLD_FETCH_SUCCESS });
	} catch (e) {
		dispatch({ type: CLEAR_OLD_FETCH_FAIL });
	}
};

export const importProducts = (file) => async (dispatch: any) => {
	const formData = new FormData();
	formData.append('file', file);

	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
			'Content-Type': 'multipart/form-data',
		},
	};

	try {
		const response = await axios.post(`${BASE_URL}/api/products/import-csv`, formData, config);
		dispatch({ type: IMPORT_PRODUCTS_SUCCESS });
		return Promise.resolve(response.data);
	} catch (e) {
		dispatch({
			type: SET_ALERT,
			payload: {
				message: e.response?.data?.error || 'Failed to import products',
				status: 'error',
			},
		});
		dispatch({ type: IMPORT_PRODUCTS_FAIL });
		return Promise.reject(e);
	}
};

export const deactivateProduct = (id: number) => async (dispatch: any) => {
	const config = { headers: { 'x-auth-token': localStorage.getItem('x-auth-token') } };
	try {
		await axios.put(`${BASE_URL}/api/products/${id}/deactivate`, {}, config);
		dispatch({ type: SET_ALERT, payload: { message: 'Product deactivated.', status: 'success' } });
		return Promise.resolve();
	} catch (e) {
		dispatch({ type: SET_ALERT, payload: { message: 'Failed to deactivate product.', status: 'error' } });
		return Promise.reject(e);
	}
};

export const updateProduct = (id: any, data: any) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
			'Content-Type': 'multipart/form-data',
		},
	};
	try {
		await axios.put(`${BASE_URL}/api/update-product/${id}`, data, config);
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Product updated successfully', status: 'success' },
		});
		dispatch(getProductByID(id));
	} catch (e: any) {
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Fail to update product', status: 'error' },
		});
	}
};
